module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [(_vm.statusList) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingProviders),
      expression: "loadingProviders"
    }],
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item1) {
    return _c('th', {
      key: item1.idCompanyDataStatus,
      style: ('text-align: center; vertical-align: middle; width: ' + (100 / 3) + '%')
    }, [_vm._v(_vm._s(item1.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.companyDataStatus), function(item1) {
    return _c('td', {
      key: item1.idCompanyDataStatus,
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item1.idCompanyDataStatus)
        }
      }
    }, [_vm._v(_vm._s(_vm.getCountByStatus(item1.idCompanyDataStatus)))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-bottom": "10px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('countries-group', {
    attrs: {
      "filter": _vm.filters[3],
      "show-all-button": false
    },
    on: {
      "update-filter": _vm.updateFilter
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', {
    staticClass: "filters-container",
    attrs: {
      "type": "flex",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Etapa"
    },
    model: {
      value: (_vm.filters[2].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[2], "value", $$v)
      },
      expression: "filters[2].value"
    }
  }, _vm._l((_vm.companyDataStage), function(item) {
    return _c('el-option', {
      key: item.stage,
      attrs: {
        "value": item.idStage,
        "label": item.stage
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingProviders),
      expression: "loadingProviders"
    }],
    attrs: {
      "id": "tablaProveedores",
      "data": _vm.newProviders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, [_vm._l((_vm.titles), function(title) {
    return (_vm.country === 'Argentina') ? _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.titlesPeru), function(title) {
    return (_vm.country === 'Peru') ? _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.country !== 'Peru') ? _c('el-table-column', {
    attrs: {
      "label": "Servicios",
      "width": 150
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rubros), function(rubro, index) {
          return _c('span', {
            key: rubro.idRubro
          }, [_vm._v("\n                    " + _vm._s(rubro.nombre) + "\n                    "), ((index + 1) < scope.row.rubros.length) ? _c('span', [_vm._v("\n                      /\n                    ")]) : _vm._e()])
        })
      }
    }], null, false, 3548534837)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center',
      "width": 100,
      "label": 'Alta de Usuario'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.country === 'Argentina') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ver",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-' + scope.row.fiscalId,
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idCompany, scope.row.idFIT, scope.row.codCountry)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.country === 'Peru') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ver",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idCompany, scope.row.idFIT, scope.row.codCountry)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd1651fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/NewProviders.vue
// module id = 656
// module chunks = 1